import React, { Component } from "react";
import { connect } from "react-redux";
import CommentsComponent from "../../../NestedComponents/widgets/commentsComponent";
import adminService from "../../../Services/adminService";
import { minimum4Letters } from "../../../global/popupMessages";
import { toast } from "react-toastify";
import Bookkeeping from "./bookkeeping";
import EditModeOptions from "./editModeOptions";
import UserCard from "./userCard";
import { sortMembersActiveFirst } from "./memberOrdering";

import Swal from "sweetalert2";
import SupportCard from "./supportCard";

import { COMMENT_LABEL_TYPES, COMMENT_TYPES, USER_ROLES, PRODUCT_TYPES, COMMENT_UPDATE_ACTION_TYPES } from "../../../global/userConstants";

const { sales: SALES } = COMMENT_TYPES;
const { assignments: ASSIGNMENTS } = COMMENT_TYPES;
const { communications: COMMUNICATIONS } = COMMENT_TYPES;
class AdminSpecificUserManager extends Component {
  memberUpdateLocks = {};

  state = {
    originalUserEmail: "",
    salesAccs: [],
    userStatusesArr: [],
    userCoursesStatusesArr: [],
    isNotEditMode: true,
    isPopupOpen: false,
    userAssignments: [],
    userAssignmentsCopy: [],
    userData: null,
    userDataCopy: null,
    btaxMembers: [],
    bquickMembers: [],
    focusedViewTypes: [PRODUCT_TYPES.btax, PRODUCT_TYPES.bquick, PRODUCT_TYPES.courses],
    changesObj: {},
    members: []
  };

  componentDidMount() {
    const userId = this.props.match.params.userId;
    if (!userId) this.props.history.push("/admin/users-manager");
    const role = localStorage.getItem("role");
    const isAllowedEditsInPopup = role === USER_ROLES.admin || role === USER_ROLES.salesManager ? true : false;

    adminService.getUsersBySearchKey(userId, true).then((res) => {
      if (res["success"]) {
        let userData = res["usersList"][0];
        const members = userData?.members || [];

        const btaxMembers = sortMembersActiveFirst(
          members.filter((member) => member.membershipType === PRODUCT_TYPES.btax)
        );
        const bquickMembers = sortMembersActiveFirst(members.filter((member) => member.membershipType === PRODUCT_TYPES.bquick));

        userData.comments = userData.comments.sort(sortCommentsByImportanceAndDate);

        userData.sales = userData.sales.sort((a, b) => new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime());

        const userDataCopy = { ...userData };
        this.setState(
          { isAllowedEditsInPopup, userData, userDataCopy, originalUserEmail: userData.email, btaxMembers, bquickMembers, members },
          () => {
            // This is just setting btax as view type... might be deleted later
            this.changeViewType(PRODUCT_TYPES.bquick);

            // after all is loaded i want to check for possible similar user cards.
            adminService.searchSimilarCard(userId, userData).then((res) => {
              if (res.success) {
                if (res.listOfSimilarCards && res.listOfSimilarCards[0]) {
                  let msg = "מספרי הכרטיסים הבאים זוהו עם כפילות נתונים: ";
                  for (const similarCard of res.listOfSimilarCards) {
                    msg += similarCard.cardNum + ", ";
                  }
                  msg = msg.substring(0, msg.lastIndexOf(", "));
                  toast.warn(msg, {
                    position: toast.POSITION.TOP_LEFT,
                    autoClose: false
                  });
                }
              }
            });
          }
        );
      }
    });

    adminService.salesListAndClientAssignments(userId).then((res) => {
      if (res["success"]) {
        const userAssignments = res["assignments"];
        const salesAccs = res["salesAccs"];

        const userAssignmentsCopy = [...userAssignments];
        this.setState({ userAssignments, userAssignmentsCopy, salesAccs });
      }
    });

    // init constant data like statuses
    // get user statuses/states for btax product (- for btax and bquick) and courses
    adminService.getClientProductStatuses([PRODUCT_TYPES.btax, PRODUCT_TYPES.courses]).then((productStatuses) => {
      this.setState({
        userStatusesArr: productStatuses[PRODUCT_TYPES.btax] || [],
        userCoursesStatusesArr: productStatuses[PRODUCT_TYPES.courses] || []
      });
    });
  }

  render() {
    const { userData } = this.state;
    return (
      <div className="admin-user-panel">
        {this.state.isPopupOpen ? (
          <CommentsComponent
            isAllowedEditsInPopup={this.state.isAllowedEditsInPopup}
            closePopUp={() => {
              this.setState({ isPopupOpen: false });
            }}
            handleNewComment={this.handleNewComment}
            finishEditRow={this.finishEditRow}
            handleEditCommunicationsRowValue={this.handleEditCommunicationsRowValue}
            toggleAssignmentCompleted={this.toggleAssignmentCompleted}
            deleteRow={this.deleteRow}
            focusedItemWithComments={this.state.userData}
            userAssignments={this.state.userAssignments}
            hasWritenBy={true}
            officeName={userData ? userData.officeName : ""}
            commentsType={this.state.commentsType}
            focusedViewTypes={this.state.focusedViewTypes}
            salesAccs={this.state.salesAccs}
            btaxMembers={this.state.btaxMembers}
          />
        ) : null}

        {this.state.userData ? (
          <div className="admin-edit-user-con">
            <EditModeOptions
              isNotEditMode={this.state.isNotEditMode}
              isAllowedEditsInPopup={this.state.isAllowedEditsInPopup}
              toggleEditMode={this.toggleEditMode}
              toggleBookKeepingMode={this.toggleBookKeepingMode}
              isBookKeepingView={this.state.isBookKeepingView}
              toggleSupportPopup={this.toggleSupportPopup}
              isSupportPopupOpen={this.state.isSupportPopupOpen}
              deleteUserCard={this.deleteUserCard}
              saveUserChanges={this.saveUserChanges}
              history={this.props.history}
            />

            {this.state.isBookKeepingView || this.state.isSupportPopupOpen ? (
              <>
                {this.state.isBookKeepingView ? (
                  <Bookkeeping
                    isNotEditMode={this.state.isNotEditMode}
                    bookKeepingEmail={userData.bookKeepingEmail}
                    bookKeepingName={userData.bookKeepingName}
                    handleChange={this.handleChange}
                  />
                ) : (
                  <SupportCard cardNum={this.state.userData.cardNum} officeName={this.state.userData.officeName} />
                )}
              </>
            ) : (
              <UserCard
                isAllowedEditsInPopup={this.state.isAllowedEditsInPopup}
                userData={this.state.userData}
                userStatusesArr={this.state.userStatusesArr}
                userCoursesStatusesArr={this.state.userCoursesStatusesArr}
                focusedViewTypes={this.state.focusedViewTypes}
                isNotEditMode={this.state.isNotEditMode}
                userAssignments={this.state.userAssignments}
                openCommentsPopup={this.openCommentsPopup}
                changeViewType={this.changeViewType}
                handleChange={this.handleChange}
                handleStatusChange={this.handleStatusChange}
                salesAccs={this.state.salesAccs}
                bquickMembers={this.state.bquickMembers}
                btaxMembers={this.state.btaxMembers}
                handleMemberUpdate={this.handleMemberUpdate}
                handleMemberChange={this.handleMemberChange}
                handleMemberAbilitiesChange={this.handleMemberAbilitiesChange}
                tryAddNewMemberAndPushList={this.tryAddNewMemberAndPushList}
                initMemberReconf={this.initMemberReconf}
                transferMemberToOtherCard={this.transferMemberToOtherCard}
                resetStations={this.resetStations}
              />
            )}
          </div>
        ) : null}
      </div>
    );
  }

  changeViewType = (viewsTypeToSet) => {
    let focusedViewTypes = [...this.state.focusedViewTypes];

    let userData = { ...this.state.userDataCopy };
    let userAssignments = [...this.state.userAssignmentsCopy];
    if (viewsTypeToSet === "all") {
      focusedViewTypes = ["btax", "bquick", "courses"];
    } else {
      if (focusedViewTypes.includes(viewsTypeToSet)) {
        if (focusedViewTypes.length === 1) return;
        focusedViewTypes = focusedViewTypes.filter((x) => x !== viewsTypeToSet);
      } else focusedViewTypes.push(viewsTypeToSet);
    }

    if (!focusedViewTypes.includes("btax")) {
      delete userData["btaxStatus"];

      userData.comments = userData.comments.filter((item) => this.keyTryToRemove(item, focusedViewTypes, "btax", "bquick", "courses"));
      userData.sales = userData.sales.filter((item) => this.keyTryToRemove(item, focusedViewTypes, "btax", "bquick", "courses"));
      userAssignments = userAssignments.filter((item) => this.keyTryToRemove(item, focusedViewTypes, "btax", "bquick", "courses"));

      focusedViewTypes = focusedViewTypes.filter((x) => x !== "btax");
    }

    if (!focusedViewTypes.includes("bquick")) {
      delete userData["bquickStatus"];

      userData.comments = userData.comments.filter((item) => this.keyTryToRemove(item, focusedViewTypes, "bquick", "btax", "courses"));
      userData.sales = userData.sales.filter((item) => this.keyTryToRemove(item, focusedViewTypes, "bquick", "btax", "courses"));
      userAssignments = userAssignments.filter((item) => this.keyTryToRemove(item, focusedViewTypes, "bquick", "btax", "courses"));

      focusedViewTypes = focusedViewTypes.filter((x) => x !== "bquick");
    }

    if (!focusedViewTypes.includes("courses")) {
      delete userData["silverStatus"];
      delete userData["goldStatus"];
      delete userData["platinumStatus"];

      userData.comments = userData.comments.filter((item) => this.keyTryToRemove(item, focusedViewTypes, "courses", "btax", "bquick"));
      userData.sales = userData.sales.filter((item) => this.keyTryToRemove(item, focusedViewTypes, "courses", "btax", "bquick"));
      userAssignments = userAssignments.filter((item) => this.keyTryToRemove(item, focusedViewTypes, "courses", "btax", "bquick"));

      focusedViewTypes = focusedViewTypes.filter((x) => x !== "courses");
    }

    this.setState({ focusedViewTypes, userData, userAssignments });
  };

  keyTryToRemove = (item, focusedViewTypes, removingKey, key1ToLeave, key2ToLeave) => {
    const commentTags = item.commentTags || item.assignmentTags;
    if (!commentTags.includes(removingKey)) return true;
    if (commentTags.includes(key1ToLeave) && focusedViewTypes.includes(key1ToLeave)) return true;
    if (commentTags.includes(key2ToLeave) && focusedViewTypes.includes(key2ToLeave)) return true;
    return false;
  };

  saveUserChanges = (e, noPopup) => {
    if (!noPopup) {
      Swal.fire({
        title: "לשמור שינויי כרטיס לקוח?",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          const dataToUpdate = { ...this.state.userData };
          if (this.state.changeMainEmail) {
            dataToUpdate["changeMainEmail"] = this.state.changeMainEmail;
            dataToUpdate["originalUserEmail"] = this.state.originalUserEmail;
          }

          adminService.adminUpdateUserData(this.state.userData.cardNum, dataToUpdate, this.state.userDataCopy, "UPDATE").then((res) => {
            if (res["success"]) {
              Swal.fire("שינויים נשמרו בהצלחה", "", "success");
              this.setState({ isNotEditMode: !this.state.isNotEditMode, userDataCopy: dataToUpdate });

              /// reset situation if an admin changed a client main email
              if (this.state.changeMainEmail) {
                this.setState({ changeMainEmail: false, originalUserEmail: dataToUpdate.email });
              }
            }
          });
        }
      });
    } else {
      adminService.adminUpdateUserData(this.state.userData.cardNum, this.state.userData, this.state.userDataCopy, "UPDATE").then((res) => {
        this.setState({ userDataCopy: { ...this.state.userData } });
      });
    }
  };

  deleteUserCard = () => {
    Swal.fire({
      title: "אתה עומד למחוק כרטיס לקוח",
      text: "פעולה זו הינה בלתי הפיכה",
      showCancelButton: true,
      icon: "warning"
    }).then((result) => {
      if (result.value) {
        adminService.adminDeleteUserCard(this.state.userData.cardNum).then((res) => {
          if (res["success"]) {
            if (res.membersExist) {
              Swal.fire("מחיקת כרטיס נכשלה", "לא ניתן למחוק כרטיס עם משתמשים", "warning");
              return;
            }
            Swal.fire("שינויים נשמרו בהצלחה", "", "success").then(() => {
              this.props.history.push("/admin/users-manager");
            });
          }
        });
      }
    });
  };

  handleChange = (e) => {
    const userData = { ...this.state.userData };
    // var userDataCopy = { ...this.state.userDataCopy };

    if (e.target.value === " ") e.target.value = "";
    userData[e.target.id] = e.target.value;
    // userDataCopy[e.target.id] = e.target.value;
    this.setState({ userData }); //userDataCopy
  };

  handleStatusChange = (statusType, newStatus) => {
    const userData = { ...this.state.userData };
    // var userDataCopy = { ...this.state.userDataCopy };

    userData[statusType] = newStatus;
    // userDataCopy[statusType] = newStatus;

    this.setState({ userData }, () => {
      this.saveUserChanges(null, true);
    });
  };

  handleMemberChange = (type, id, index, val) => {
    const rightList = [...this.state[type]];
    const changesObj = { ...this.state.changesObj };
    const memberToUpdate = { ...rightList[index] };
    if (id === "firstName" || id === "lastName") {
      if (memberToUpdate.firstName === undefined || memberToUpdate.firstName === null) {
        memberToUpdate.firstName = getFirstNameFromFullName(memberToUpdate.fullName);
      }
      if (memberToUpdate.lastName === undefined || memberToUpdate.lastName === null) {
        memberToUpdate.lastName = getLastNameFromFullName(memberToUpdate.fullName);
      }
      memberToUpdate[id] = val;
      memberToUpdate.fullName = buildFullName(memberToUpdate.firstName, memberToUpdate.lastName, memberToUpdate.fullName);
    } else {
      memberToUpdate[id] = val;
    }
    rightList[index] = memberToUpdate;
    changesObj[id] = val;
    if (id === "firstName" || id === "lastName") changesObj.fullName = memberToUpdate.fullName;
    this.setState({
      [type]: rightList,
      changesObj
    });
  };

  handleMemberAbilitiesChange = (type, index, val) => {
    const rightList = [...this.state[type]];
    rightList[index].abilities = val;
    this.setState({ [type]: rightList });
  };

  tryAddNewMemberAndPushList = (data, newMemberType) => {
    return new Promise((resolve) => {
      const jsonDataForServer = {
        email: data.newEmail.replace(/ /g, ""),
        firstName: data.newFirstName.trim().replace(/  +/g, ""),
        lastName: data.newLastName.trim().replace(/  +/g, ""),
        endOfSubscription: data.newEndOfSubscription,
        abilities: data.newAbilities,
        membershipType: newMemberType,
        cardNum: this.state.userData.cardNum,
        jobType: data.newJobType,
        softwareServiceType: data.newSoftwareServiceType,
        status: data.newStatus,
        isUpdateClientBeforeEndSub: data.isUpdateClientBeforeEndSub,
        licenseNumber: data.newLicenseNumber,
        mobile: data.newMobile
      };

      if (newMemberType === PRODUCT_TYPES.btax) {
        jsonDataForServer.disableTaxAuthorityDocumentConfirmation = data.newDisableTaxAuthorityDocumentConfirmation;
      }

      if (data.attachRole) jsonDataForServer.attachRole = data.attachRole;
      if (data.adminSetManualPassword) jsonDataForServer.adminSetManualPassword = data.adminSetManualPassword;

      adminService.addNewMemberFromCard(jsonDataForServer).then((res) => {
        if (res["success"]) {
          if (res["isEmailTaken"]) {
            Swal.fire("", 'דוא"ל זה כבר בשימוש בכרטיס - ' + res.belongToCardNum, "warning");
          } else if (res["isInPendingList"]) {
            Swal.fire("", 'דוא"ל זה נמצא ברשימת ה - "ממתינים לאישור"', "warning");
          } else {
            Swal.fire("", "משתמש נוסף בהצלחה", "success");
            const copyList = [...this.state[newMemberType + "Members"]];
            jsonDataForServer.fullName = jsonDataForServer.firstName + " " + jsonDataForServer.lastName;
            jsonDataForServer.belongToCardNum = jsonDataForServer.cardNum;
            delete jsonDataForServer.cardNum;
            copyList.push(jsonDataForServer);
            this.setState({ [newMemberType + "Members"]: sortMembersActiveFirst(copyList) });

            resolve();
          }
        }
      });
    });
  };

  handleMemberUpdate = (type, index, action) => {
    return new Promise((resolve) => {
      Swal.fire({
        title: action,
        text: "האם אתה בטוח שאתה רוצה לעשות את הפעולה הבאה?",
        icon: "warning",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          const lockKey = `${type}-${index}-${action}`;
          if (this.memberUpdateLocks[lockKey]) return resolve(false);
          this.memberUpdateLocks[lockKey] = true;

          const memberNeedsAction = [...this.state[type]];
          const originalMember = this.getOriginalMember(memberNeedsAction[index]);
          const changesObj = this.getMemberChanges(originalMember, memberNeedsAction[index]);
          adminService.handleMemberUpdate(memberNeedsAction[index], action, changesObj, originalMember).then((res) => {
            this.memberUpdateLocks[lockKey] = false;
            if (this.showMemberUpdateError(res)) {
              if (action === "UPDATE" && this.shouldResetMemberEmail(res)) {
                this.resetMemberEmail(type, index, originalMember);
              }
              return resolve(false);
            }
            if (res?.success === true && !this.hasMemberUpdateError(res)) {
              if (action === "DELETE") {
                memberNeedsAction.splice(index, 1);
                this.setState({ [type]: memberNeedsAction, members: this.removeMemberFromOriginalList(originalMember) });
              } else {
                this.setState({
                  [type]: sortMembersActiveFirst(memberNeedsAction),
                  members: this.updateOriginalMemberList(memberNeedsAction[index]),
                  changesObj: {}
                });
              }
              Swal.fire("המשתמש עודכן בהצלחה", "", "success");
              return resolve(true);
            }
            Swal.fire("עדכון המשתמש נכשל", res?.msg || "", "error");
            return resolve(false);
          }, () => {
            this.memberUpdateLocks[lockKey] = false;
            Swal.fire("עדכון המשתמש נכשל", "", "error");
            return resolve(false);
          });
        } else {
          return resolve(false);
        }
      });
    });
  };

  getOriginalMember = (member) => {
    const memberId = member?._id?.toString?.() || member?._id;
    return this.state.members.find((originalMember) => {
      const originalMemberId = originalMember?._id?.toString?.() || originalMember?._id;
      return memberId && originalMemberId === memberId;
    });
  };

  getMemberChanges = (originalMember = {}, updatedMember = {}) => {
    const changesObj = {};
    const fieldsToCompare = [
      "email",
      "firstName",
      "lastName",
      "fullName",
      "licenseNumber",
      "mobile",
      "endOfSubscription",
      "status",
      "jobType",
      "abilities",
      "softwareServiceType",
      "isUpdateClientBeforeEndSub",
      "hasStationsProtection",
      "stationsAmount",
      "disableTaxAuthorityDocumentConfirmation",
      "attachRole"
    ];

    fieldsToCompare.forEach((fieldName) => {
      if (JSON.stringify(originalMember[fieldName]) !== JSON.stringify(updatedMember[fieldName])) {
        changesObj[fieldName] = updatedMember[fieldName];
      }
    });
    return changesObj;
  };

  updateOriginalMemberList = (updatedMember) => {
    const updatedMemberId = updatedMember?._id?.toString?.() || updatedMember?._id;
    return this.state.members.map((member) => {
      const memberId = member?._id?.toString?.() || member?._id;
      return updatedMemberId && memberId === updatedMemberId ? { ...updatedMember } : member;
    });
  };

  removeMemberFromOriginalList = (memberToRemove) => {
    const memberToRemoveId = memberToRemove?._id?.toString?.() || memberToRemove?._id;
    return this.state.members.filter((member) => {
      const memberId = member?._id?.toString?.() || member?._id;
      return !memberToRemoveId || memberId !== memberToRemoveId;
    });
  };

  shouldResetMemberEmail = (res) => {
    return res?.isEmailTaken || res?.isInvalidEmail || res?.isInPendingList;
  };

  hasMemberUpdateError = (res) => {
    return res?.isEmailTaken || res?.isInvalidEmail || res?.isInPendingList || res?.btaxUpdateFailed;
  };

  resetMemberEmail = (type, index, originalMember = {}) => {
    const memberNeedsAction = [...this.state[type]];
    if (!memberNeedsAction[index]) return;
    memberNeedsAction[index] = { ...memberNeedsAction[index], email: originalMember.email || "" };
    this.setState({ [type]: memberNeedsAction });
  };

  showMemberUpdateError = (res) => {
    if (!res) {
      Swal.fire("עדכון המשתמש נכשל", "", "error");
      return true;
    }
    if (res.isEmailTaken) {
      Swal.fire("", 'דוא"ל זה כבר בשימוש בכרטיס - ' + (res.belongToCardNum || ""), "warning");
      return true;
    }
    if (res.isInvalidEmail) {
      Swal.fire("", 'כתובת הדוא"ל אינה תקינה', "warning");
      return true;
    }
    if (res.isInPendingList) {
      Swal.fire("", 'דוא"ל זה נמצא ברשימת ה - "ממתינים לאישור"', "warning");
      return true;
    }
    if (res.btaxUpdateFailed) {
      Swal.fire("עדכון ביטקס נכשל", res.msg || "", "error");
      return true;
    }
    return false;
  };

  initMemberReconf = (type, index, action) => {
    return new Promise((resolve) => {
      Swal.fire({
        title: action === "EMAIL_CONF" ? 'שליחת דוא"ל נוסף לאישור מייל' : "איפוס סיסמה",
        text: "האם אתה בטוח שאתה רוצה לעשות את הפעולה הבאה?",
        icon: "warning",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          adminService.initMemberReconf(this.state[type][index], action).then((res) => {
            if (res["success"]) {
              Swal.fire("", 'דוא"ל נשלח ללקוח בהצלחה', "success");
              return resolve();
            }
          });
        }
      });
    });
  };

  resetStations = (member) => {
    return new Promise((resolve) => {
      Swal.fire({
        title: "איפוס תחנות עבודה",
        text: "האם אתה בטוח שאתה רוצה לעשות את הפעולה הבאה?",
        icon: "warning",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          adminService.resetStations(this.state.userData.cardNum, member.email, member.stationsAmount).then((res) => {
            if (res["success"]) {
              Swal.fire("", "איפוס עמדות בוצע בהלצחה", "success");
              return resolve();
            }
          });
        }
      });
    });
  };

  transferMemberToOtherCard = (membershipType, index, newCardNum) => {
    if (isNaN(newCardNum)) {
      Swal.fire("", "ניתן להזין רק מספר לכרטיס חדש", "success");
      return;
    }
    Swal.fire({
      title: "אתה הולך להעביר לקוח לכרטיס - " + newCardNum,
      text: "האם אתה בטוח שאתה רוצה לעשות את הפעולה הזאת?",
      icon: "warning",
      showCancelButton: true
    }).then((result) => {
      if (result.value) {
        const memberNeedsAction = [...this.state[membershipType]];
        const data = {
          cardNum: memberNeedsAction[index].belongToCardNum,
          email: memberNeedsAction[index].email,
          newCardNum,
          membershipType: membershipType.replace("Members", "")
        };
        adminService.transferMemberToOtherCard(data).then((res) => {
          if (res["success"]) {
            Swal.fire("", "לקוח הועבר לכרטיס אחר בהצלחה", "success");
            memberNeedsAction.splice(index, 1);
            this.setState({ [membershipType]: memberNeedsAction });
          } else if (res.cardDoesntExist) {
            Swal.fire({ title: "שילוב לכרטיס אחר נכשל", text: "המספר המבוקש לא קיים בשום כרטיס", icon: "warning" });
          }
        });
      }
    });
  };

  openCommentsPopup = (popupType) => {
    this.setState({ isPopupOpen: true, commentsType: popupType });
  };

  deleteRow = (itemIdToRemove, index, callback) => {
    const comment = this.state.userData?.comments?.find((comment) => comment.identifier === itemIdToRemove);
    if (comment?.commentLabel === COMMENT_LABEL_TYPES.important) {
      Swal.fire("", "לא ניתן למחוק תגובה שמסומנת כחשובה", "warning");
      return;
    }
    Swal.fire({
      title: "האם אתה בטוח?",
      text: "למחוק את הרשומה?",
      showCancelButton: true
    }).then((result) => {
      if (result.value) {
        adminService.adminUpdateUserComments({ itemIdToRemove }, "DELETE", this.state.commentsType).then((res) => {
          if (res["success"]) {
            let btaxMembers = null;
            let shouldUpdateBtaxMembers = false;
            if (this.state.commentsType === ASSIGNMENTS) {
              let userAssignments = [...this.state.userAssignments];
              let userAssignmentsCopy = [...this.state.userAssignmentsCopy];
              const copyIndexToRemove = this.getIndexOfMainCopyData(index, userAssignments, userAssignmentsCopy);

              userAssignments.splice(index, 1);
              userAssignmentsCopy.splice(copyIndexToRemove, 1);

              this.setState({ userAssignments, userAssignmentsCopy }, callback);
            } else if (this.state.commentsType === COMMUNICATIONS) {
              let userData = { ...this.state.userData };
              let userDataCopy = { ...this.state.userDataCopy };
              const copyIndexToRemove = this.getIndexOfMainCopyData(index, userData.comments, userDataCopy.comments);

              userData.comments.splice(index, 1);
              userDataCopy.comments.splice(copyIndexToRemove, 1);

              this.setState({ userData, userDataCopy }, callback);
            } else {
              //like sales
              let userData = { ...this.state.userData };
              let userDataCopy = { ...this.state.userDataCopy };
              const copyIndexToRemove = this.getIndexOfMainCopyData(index, userData.sales, userDataCopy.sales);

              userData.sales.splice(index, 1);
              userDataCopy.sales.splice(copyIndexToRemove, 1);

              //if sale had related members - update the btaxMembers state to remove sales from members
              if (this.state.commentsType === SALES) {
                if (!res?.saleRemovedFromAllRelatedMembers) {
                  Swal.fire("אירעה תקלה", "המכירה לא נמחקה אצל כל המשתמשים המשוייכים לה", "error");
                } else {
                  //update btaxMembers state only if sale removal worked for all selected members
                  shouldUpdateBtaxMembers = true;
                  btaxMembers = this.state.btaxMembers.map((member) => {
                    return { ...member, relatedSales: member.relatedSales.filter((id) => id !== itemIdToRemove) }; //go over the members and remove the deleted sale from each member btaxMembers state
                  });
                }
              }
              const statesUpdates = { userData, userDataCopy };
              if (shouldUpdateBtaxMembers && btaxMembers) statesUpdates.btaxMembers = btaxMembers;
              this.setState(statesUpdates, callback);
            }
          }
        });
      }
    });
  };

  handleEditCommunicationsRowValue = (itemBeingEditted, index, callback) => {
    const userData = { ...this.state.userData },
      userDataCopy = { ...this.state.userDataCopy };
    const copyIndexToModify = this.getIndexOfMainCopyData(index, userData.comments, userDataCopy.comments);

    //check if comment label changed
    const { commentLabel: newCommentLabel } = itemBeingEditted,
      OldUserDataCommentLabel = userData.comments[index]?.commentLabel,
      OldUserDataCopyCommentLabel = userDataCopy.comments[copyIndexToModify]?.commentLabel;
    const commentLabelChanged = OldUserDataCommentLabel !== newCommentLabel || OldUserDataCopyCommentLabel !== newCommentLabel;

    userData.comments[index] = itemBeingEditted;
    userDataCopy.comments[copyIndexToModify] = itemBeingEditted;

    if (commentLabelChanged) {
      //sort comments if a comment label was change (such as important label - important comments should appear first)
      userData.comments.sort(sortCommentsByImportanceAndDate);
      userDataCopy.comments.sort(sortCommentsByImportanceAndDate);
    }

    this.setState({ userData, userDataCopy }, callback);
  };

  finishEditRow = (itemBeingEditted, index, callback) => {
    if (this.state.commentsType === ASSIGNMENTS) {
      if (itemBeingEditted.assignmentTxt.length < 4 || !itemBeingEditted.dueDate) {
        Swal.fire("", "חובה כל השדות וגם לפחות 4 תווים בטקטס חופשי", "warning");
        return;
      }
    } else if (this.state.commentsType === COMMUNICATIONS) {
      if (itemBeingEditted.commentTxt.length < 4) {
        Swal.fire("", "חובה כל השדות וגם לפחות 4 תווים בטקטס חופשי", "warning");
        return;
      }
    }

    Swal.fire({
      title: "האם אתה בטוח?",
      text: "לערוך את הרשומה?",
      showCancelButton: true
    }).then((result) => {
      if (result.value) {
        adminService.adminUpdateUserComments(itemBeingEditted, "UPDATE", this.state.commentsType).then((res) => {
          if (res["success"]) {
            if (this.state.commentsType === ASSIGNMENTS) {
              const userAssignments = [...this.state.userAssignments];
              const userAssignmentsCopy = [...this.state.userAssignmentsCopy];
              const copyIndexToModify = this.getIndexOfMainCopyData(index, userAssignments, userAssignmentsCopy);

              userAssignments[index] = itemBeingEditted;
              userAssignmentsCopy[copyIndexToModify] = itemBeingEditted;

              this.setState({ userAssignments, userAssignmentsCopy }, callback);
            } else if (this.state.commentsType === COMMUNICATIONS) {
              const userData = { ...this.state.userData };
              const userDataCopy = { ...this.state.userDataCopy };
              const copyIndexToModify = this.getIndexOfMainCopyData(index, userData.comments, userDataCopy.comments);

              userData.comments[index] = itemBeingEditted;
              userDataCopy.comments[copyIndexToModify] = itemBeingEditted;
              this.setState({ userData, userDataCopy }, callback);
            } else {
              // SALES
              const userData = { ...this.state.userData };
              const userDataCopy = { ...this.state.userDataCopy };
              const copyIndexToModify = this.getIndexOfMainCopyData(index, userData.sales, userDataCopy.sales);

              userData.sales[index] = itemBeingEditted;
              userDataCopy.sales[copyIndexToModify] = itemBeingEditted;

              this.setState({ userData, userDataCopy }, callback);
            }
          }
        });
      }
    });
  };

  toggleAssignmentCompleted = (assignment, callback) => {
    const isCompleted = !assignment.isCompleted;
    const updatedAssignment = {
      ...assignment,
      isCompleted
    };

    adminService.adminUpdateUserComments(updatedAssignment, "UPDATE", ASSIGNMENTS).then((res) => {
      if (res["success"]) {
        const assignmentId = updatedAssignment._id && updatedAssignment._id.toString();
        const updateAssignmentList = (assignments) =>
          assignments.map((item) => (item._id && item._id.toString() === assignmentId ? updatedAssignment : item));

        this.setState(
          {
            userAssignments: updateAssignmentList(this.state.userAssignments),
            userAssignmentsCopy: updateAssignmentList(this.state.userAssignmentsCopy)
          },
          callback
        );
      }
    });
  };

  getIndexOfMainCopyData = (index, list, listCopy) => {
    for (let copyIndex = 0; copyIndex < listCopy.length; copyIndex++) {
      const focusComment = listCopy[copyIndex];
      if (focusComment.identifier && focusComment.identifier === list[index].identifier) {
        return copyIndex;
      } else if (focusComment._id && focusComment._id === list[index]._id) {
        return copyIndex;
      }
    }
  };

  toggleBookKeepingMode = () => {
    this.setState({ isBookKeepingView: !this.state.isBookKeepingView, isSupportPopupOpen: false });
  };

  toggleSupportPopup = () => {
    this.setState({ isSupportPopupOpen: !this.state.isSupportPopupOpen, isBookKeepingView: false });
  };

  toggleEditMode = () => {
    this.setState({ isNotEditMode: !this.state.isNotEditMode });
  };

  handleNewComment = (
    commentsType,
    selectedProduct,
    newCommentTxt,
    commentTags,
    commentLabel,
    newAssignmentDate,
    newAssignmentTime,
    otherSalesmanTask,
    saleRelatedMembers,
    callback
  ) => {
    let updates;
    let updateAction;
    if (commentsType === SALES) {
      if (!selectedProduct || !selectedProduct.productType || !selectedProduct.price) {
        Swal.fire("", "יש למלא מחיר ושם שירות", "warning");
        return;
      }

      let priceWithoutCommas = selectedProduct.price.replace(/,/g, "");
      if (priceWithoutCommas.includes("-")) {
        priceWithoutCommas = priceWithoutCommas.replace(/-/g, "");
        priceWithoutCommas = "-" + priceWithoutCommas;
      }
      if (isNaN(priceWithoutCommas)) {
        Swal.fire("", "שדה המחיר חייב להיות מספר", "warning");
        return;
      }
      selectedProduct.commentTags = commentTags;
      //add the members related to sale - so it will record the sale for the members
      if (saleRelatedMembers?.length) selectedProduct.saleRelatedMembers = saleRelatedMembers;
      updates = selectedProduct;
      updateAction = COMMENT_UPDATE_ACTION_TYPES.SALES;
    } else if (commentsType === ASSIGNMENTS) {
      if (newCommentTxt.length < 4 || !newAssignmentDate || !newAssignmentTime) {
        Swal.fire("", "חובה כל השדות וגם לפחות 4 תווים בטקטס חופשי", "warning");
        return;
      }
      updates = {};
      updates.dueDate = newAssignmentDate;
      updates.dueTime = newAssignmentTime;
      updates.assignmentTxt = newCommentTxt;
      updates.assignmentTags = commentTags;
      if (otherSalesmanTask) updates.otherSalesmanTask = otherSalesmanTask;
      updates.officeName = this.state.userData.officeName;
      if (!updates.officeName) {
        updates.officeName = this.state.userData.contactName1 || this.state.userData.firstName || "";
      }
      updates.userId = this.state.userData._id;
      updateAction = COMMENT_UPDATE_ACTION_TYPES.ASSIGNMENTS;
    } else {
      //COMMUNICATIONS
      if (newCommentTxt.length < 4) {
        Swal.fire("", minimum4Letters, "warning");
        return;
      }
      updates = {};
      updates["commentTxt"] = newCommentTxt;
      updates["commentTags"] = commentTags;
      updates["commentLabel"] = commentLabel;
      updateAction = "PUSH_COMMENT";
    }

    if (!commentTags) {
      Swal.fire("", "תגובה חייבת להיות שייכת לחברה", "warning");
      return;
    }

    Swal.fire({
      title: "האם אתה בטוח?",
      text: "אתה הולך להוסיף שורה חדשה",
      showCancelButton: true
    }).then((result) => {
      if (result.value) {
        adminService.adminUpdateUserData(this.state.userData.cardNum, updates, null, updateAction).then((res) => {
          if (res["success"]) {
            Swal.fire("בוצע", "", "success");
            let shouldUpdateBtaxMembers = false;
            let btaxMembers = null;
            if (commentsType === ASSIGNMENTS) {
              let userAssignments = [...this.state.userAssignments];
              let userAssignmentsCopy = [...this.state.userAssignmentsCopy];
              updates["dateCreated"] = new Date();
              updates["createdBy"] = "אתה עכשיו..";
              updates["_id"] = res["insertedId"];
              updates["dueDate"] = adminService.getCorrectDateFormat(updates["dueDate"], updates["dueTime"]);
              userAssignments.unshift(updates);
              userAssignmentsCopy.unshift(updates);
              this.setState({ userAssignments, userAssignmentsCopy }, callback);
            } else {
              let userData = this.state.userData;
              let userDataCopy = this.state.userDataCopy;

              updates["dateCreated"] = new Date();
              updates["createdBy"] = "אתה עכשיו..";
              updates["identifier"] = res["identifier"];
              if (commentsType === SALES) {
                //update sales state
                userData.sales = [...userData.sales];
                userDataCopy.sales = [...userDataCopy.sales];
                userData.sales.unshift(updates);
                userDataCopy.sales.unshift(updates);

                //if sale had related members - update the btaxMembers state to show them on the sales panel
                if (updates.saleRelatedMembers?.length) {
                  if (!res?.updatedAllSelectedMembers) {
                    Swal.fire("אירעה תקלה", "המכירה לא נרשמה אצל כל המשתמשים המשוייכים לה", "error");
                  } else {
                    //update btaxMembers state only if update worked for all selected members
                    shouldUpdateBtaxMembers = true;
                    btaxMembers = [...this.state.btaxMembers];
                    //go over the members and add the new sale to each member in btaxMembers state
                    updates.saleRelatedMembers.forEach((saleMemberId) => {
                      const btaxMember = btaxMembers.find((btaxMember) => btaxMember._id === saleMemberId);
                      btaxMember.relatedSales = !btaxMember.relatedSales
                        ? [updates.identifier]
                        : [...btaxMember.relatedSales, updates.identifier];
                    });
                  }
                }
              } else if (commentsType === COMMUNICATIONS) {
                userData.comments = [...userData.comments];
                userDataCopy.comments = [...userDataCopy.comments];

                userData.comments.unshift(updates);
                userDataCopy.comments.unshift(updates);

                //sort the comments after a new comment to make sure important (label) comments appear first
                userData.comments.sort(sortCommentsByImportanceAndDate);
                userDataCopy.comments.sort(sortCommentsByImportanceAndDate);
              } // callback here is being used to init an update in the popup of the comments
              const statesUpdates = { userData, userDataCopy };
              if (shouldUpdateBtaxMembers && btaxMembers) statesUpdates.btaxMembers = btaxMembers;
              this.setState(statesUpdates, callback);
            }
          }
        });
      }
    });
  };
}

function buildFullName(firstName, lastName, fallbackFullName) {
  const fullName = [firstName, lastName].filter(Boolean).join(" ").trim();
  return fullName || fallbackFullName || "";
}

function getFirstNameFromFullName(fullName = "") {
  return fullName.split(" ")[0] || "";
}

function getLastNameFromFullName(fullName = "") {
  const nameParts = fullName.split(" ").filter(Boolean);
  return nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
}

function sortCommentsByImportanceAndDate(comment2, comment1) {
  //A is before B in sort
  const { important } = COMMENT_LABEL_TYPES,
    { dateCreated: date1, commentLabel: label1 } = comment1,
    { dateCreated: date2, commentLabel: label2 } = comment2;
  const dateTime1 = new Date(date1).getTime(),
    dateTime2 = new Date(date2).getTime();
  if ((label1 !== important && label2 !== important) || (label1 === important && label2 === important))
    return dateTime1 - dateTime2; //both not important comments or both are important
  else if (label1 === important && label2 !== important) return 1; //A is important, B isn't
  else if (label2 === important && label1 !== important) return -1; //B is important, A isn't
  return 0;
}

const mapStateToProps = (state) => {
  return {
    userData: state.authReducer.userForEdit
  };
};

export default connect(mapStateToProps)(AdminSpecificUserManager);
